import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const COLUMNS = [
  {
    title: "Product",
    links: [
      { label: "Dashboard", to: "/product" },
      { label: "Tickets", to: "/product" },
      { label: "Dispatch", to: "/product" },
      { label: "Field App", to: "/product" },
      { label: "AI Capabilities", to: "/ai" },
      { label: "Integrations", to: "/product" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Utility Locating", to: "/solutions" },
      { label: "Contract Locators", to: "/solutions" },
      { label: "Gas & Telecom", to: "/solutions" },
      { label: "Municipalities", to: "/solutions" },
      { label: "Construction", to: "/solutions" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Pricing", to: "/pricing" },
      { label: "Request Demo", to: "/demo" },
      { label: "Support", to: "/support" },
      { label: "Privacy Policy", to: "/privacy" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-24 border-t border-white/5 bg-[#000000]">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <Logo size="md" />
          <p className="mt-4 text-sm text-[#94A3B8] leading-relaxed max-w-xs">
            The AI Operating System for Locate Ticket Management.
          </p>
          <p className="mt-6 text-xs text-[#94A3B8]/70 font-mono">
            © 2025 LocateOS. All rights reserved.
          </p>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.title}>
            <div className="text-white font-display font-bold mb-4">{col.title}</div>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-[#94A3B8] hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/5">
        <div className="container-x py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#94A3B8]">
          <div className="flex items-center gap-3">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy Policy</Link>
            <span>·</span>
            <Link to="/support" data-testid="footer-support-link" className="hover:text-white">Support</Link>
          </div>
          <div>
            Contact:{" "}
            <a className="text-[#F97316] hover:underline" href="mailto:info@locateos.com">
              info@locateos.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
